import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import smlogo from '../../images/logo/4smapper_logo.png';

const Footer = () => {
  const { t } = useTranslation('footer');
  const navigate = useNavigate();

  // 공통 이동 함수 (페이지 이동 + 최상단 렌더링)
  const handleNavigate = (path) => {
    navigate(path);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'auto' }), 0);
  };

  return (
    <div className="FooterContainer">
      <div className="FooterContents">
        <img src={smlogo} className="footer_smlogo" alt="4SMapper logo" />
        <div className="footer_context">
          <div className="footer_test">
            <div className="footer_info_title">
              <div>Address</div>
              <div>E-Mail</div>
              <div>Call</div>
              <div>Fax</div>
            </div>

            <div className="footer_info">
              <div>{t('info.adress')}</div>
              <div>info@4SMapper.com</div>
              <div>+82 70 8721 4396</div>
              <div>+82 504 400 4396</div>
            </div>

            <div className="footer_link">
              <div onClick={() => handleNavigate('/Platform')}>{t('nav.platform')}</div>
              <div onClick={() => handleNavigate('/Solution')}>{t('nav.solution')}</div>
              <div onClick={() => handleNavigate('/Products')}>{t('nav.products')}</div>
              <div onClick={() => handleNavigate('/About')}>{t('nav.about')}</div>
              <div onClick={() => handleNavigate('/Brand')}>{t('nav.brand')}</div>
            </div>
          </div>

          <div className="footer_line">Copyright © 2026 4S Mapper all right reserved</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
